import React from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import Navigation from './Navigation';
import LandingPage from './Landing';
import SignUpPage from './SignUp';
import SignInPage from './SignIn';
import PasswordForgetPage from './PasswordForget';
import HomePage from './Home';
import AccountPage from './Account';
import RepositoryPage from './Repository';
import FAQs from './faqs';
import Resources from './resources';

import * as routes from '../constants/routes';

import withAuthentication from './withAuthentication';

// when App is trnaformed with authentication the Navigation Consumer gets authUser
const App = () =>
  <Router>
    <div>
      <Navigation />

      <hr/>

      <Route exact path={routes.LANDING} component={() => <LandingPage />} />
      <Route exact path={routes.SIGN_UP} component={() => <SignUpPage />} />
      <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
      <Route exact path={routes.PASSWORD_FORGET} component={() => <PasswordForgetPage />} />
      <Route exact path={routes.REPOSITORY} component={() => <RepositoryPage />} />
      <Route exact path={routes.HOME} component={() => <HomePage />} />
      <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
      <Route exact path={routes.FAQS} component={() => <FAQs />} />
      <Route exact path={routes.RESOURCES} component={() => <Resources />} />
    </div>
  </Router>

export default withAuthentication(App);



// WEBPACK FOOTER //
// ./src/components/App.js